import { createFileRoute } from "@tanstack/react-router";
import { ResearchConsultingServicePage } from "./services_.research-consulting";

export const Route = createFileRoute("/services_/research-consulting-and-brand-audit-services")({
  head: () => ({
    meta: [
      {
        title: "Research Consulting & Brand Audit Services — KMWAdvertising",
      },
      {
        name: "description",
        content: "In-Depth Brand Equity & Market Perception Audits.",
      },
    ],
  }),
  component: ResearchConsultingServicePage,
});
